// lib
import { connect } from 'react-redux';

// components
import Meta from './Meta';

// redux
import { getCMSData } from 'shared/store/cms/selectors';

const mapStateToProps = (state: any) => {
  const cmsData = getCMSData(state);
  const { title, description, keywords } = cmsData;
  return {
    metaTitle: title,
    metaDescription: description,
    metaKeywords: keywords,
  };
};

export default connect(mapStateToProps)(Meta);
